import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { PublicAssessment } = await import('./index');
    return {
        Component: PublicAssessment,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
